import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useBrands, CATEGORIES } from '../filterConfig';

const FilterBar = () => {
    const BRANDS = useBrands();   
    const location = useLocation();
    const path = location.pathname;

    // Парсим URL: /brand/:brandSlug и/или /category/:categorySlug
    const matchBrandCat = path.match(/^\/brand\/([^/]+)\/([^/]+)$/);
    const matchBrand = path.match(/^\/brand\/([^/]+)$/);
    const matchCat = path.match(/^\/category\/([^/]+)$/);

    const activeBrandSlug = matchBrandCat ? matchBrandCat[1] : matchBrand ? matchBrand[1] : '';
    const activeCategorySlug = matchBrandCat ? matchBrandCat[2] : matchCat ? matchCat[1] : '';

    const pill = (label, to, isActive) => (
        <Link
            key={`${to}|${label}`}
            to={to}
            className={`px-6 py-3 rounded-full text-sm font-medium border transition inline-block ${isActive
                ? 'bg-[#1C1917] text-white border-[#1C1917]'
                : 'bg-white text-[#1C1917] border-[#E8E3DD] hover:border-[#1C1917]'
                }`}
        >
            {label}
        </Link>
    );

    return (
        <div className="flex flex-wrap gap-3">
            {/* «Все» — если есть активный бренд, сохраняем бренд; иначе — на главную */}
            {pill(
                'Все',
                activeBrandSlug ? `/brand/${activeBrandSlug}` : '/',
                !activeCategorySlug
            )}

            {/* Категории — при выборе активного бренда добавляются к URL бренда */}
            {CATEGORIES.map((c) =>
                pill(
                    c.label,
                    activeBrandSlug
                        ? `/brand/${activeBrandSlug}/${c.slug}`
                        : `/category/${c.slug}`,
                    activeCategorySlug === c.slug
                )
            )}

            {/* Бренды — при выборе активной категории добавляются к URL категории */}
            {BRANDS.map((b) =>
                pill(
                    b.label,
                    activeCategorySlug
                        ? `/brand/${b.slug}/${activeCategorySlug}`
                        : `/brand/${b.slug}`,
                    activeBrandSlug === b.slug
                )
            )}
        </div>
    );
};

export default FilterBar;